import ListClamp from 'components/misc/ListClamp';
import { DebriefingLessonListItem } from 'pages/debriefing/types';
import { t } from 'utils/getTranslations';
import { MaskedCell } from './DebriefingAccessIndicator';

const MAX_DESCRIPTION_CHARS = 100;

export function truncateLessonDescription(text: string): string {
    return text.length > MAX_DESCRIPTION_CHARS ? `${text.slice(0, MAX_DESCRIPTION_CHARS).trimEnd()}…` : text;
}

interface Props {
    lessons: DebriefingLessonListItem[] | null;
    accessible: boolean;
}

/**
 * "What we did well" / "What could we do better" list cell: first lesson with its relevance
 * eyebrow, truncated to ~100 chars, the rest behind a "+N more" chip. Masked on restricted rows.
 */
export function DebriefingLessonsCell({ lessons, accessible }: Props) {
    if (!accessible) {
        return <MaskedCell />;
    }
    if (!lessons || lessons.length === 0) {
        return <span className="text-fg-disabled text-[13px]">&mdash;</span>;
    }
    return (
        <ListClamp
            items={lessons}
            maxVisibleItems={1}
            getKey={(_lesson, index) => index}
            renderItem={(lesson) => (
                <div>
                    <p className="text-fg-secondary new:text-caption m-0 text-[11px]">
                        {t(`debriefing.relevance.${lesson.relevance}`)}
                    </p>
                    <p className="m-0 text-[13px]">{truncateLessonDescription(lesson.description)}</p>
                </div>
            )}
        />
    );
}
